var React = require('react');

function ArrowRightUp (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M12.002 11.1208V4.00684L4.88804 4.00684L4.88804 5.50684L9.44077 5.50684L4.35742 10.5902L5.41808 11.6508L10.502 6.56693V11.1208L12.002 11.1208Z","fill":"currentColor"}));
}

ArrowRightUp.defaultProps = {"width":"16","height":"16","viewBox":"0 0 16 16","fill":"none"};

module.exports = ArrowRightUp;

ArrowRightUp.default = ArrowRightUp;
